import { ActionFunction, redirect } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { Result } from "../../types/Result";
import { parseFormData } from "../../utils/parseFormData";
import { ExamType } from "./type";

export const examTypeAction: ActionFunction = async (
  { request, params },
  context
) => {
  const formData = await request.formData();
  const updates = parseFormData(formData);
  if (params.code === "new") {
    const result = await axiosApi.post<Result<ExamType>>(
      "/api/examTypes",
      updates
    );
    return redirect(`/examTypes/${result.data.data?.code}`);
  } else await axiosApi.put("/api/examTypes", updates);
  return redirect(`/examTypes`);
};
